{
  "name": "zeropark-frontend-publisher",
  "version": "1.17.8",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration zp-development",
    "start-cm": "ng serve --configuration cm-development",
    "build-zp-prod": "ng build --configuration zp-production && node src/gtm/inject-gtm.js zp",
    "build-zp-test": "ng build --configuration zp-test",
    "build-cm-prod": "ng build --configuration cm-production && node src/gtm/inject-gtm.js cm",
    "build-cm-test": "ng build --configuration cm-test",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@amcharts/amcharts4": "^4.10.29",
    "@amcharts/amcharts4-geodata": "^4.1.23",
    "@angular/animations": "^20.1.0",
    "@angular/cdk": "^20.1.0",
    "@angular/common": "^20.1.0",
    "@angular/compiler": "^20.1.0",
    "@angular/core": "^20.1.0",
    "@angular/forms": "^20.1.0",
    "@angular/platform-browser": "^20.1.0",
    "@angular/platform-browser-dynamic": "^20.1.0",
    "@angular/router": "^20.1.0",
    "@datadog/browser-rum": "^6.1.0",
    "@primeuix/themes": "^1.2.1",
    "@tailwindcss/postcss": "^4.1.11",
    "@w11k/ngx-componentdestroyed": "^5.0.2",
    "dayjs": "^1.11.11",
    "postcss": "^8.5.6",
    "primeicons": "^7.0.0",
    "primeng": "^20.0.0-rc.3",
    "rxjs": "^7.4.0",
    "tailwindcss": "^4.1.11",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0",
    "zxcvbn": "4.4.2"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.1.0",
    "@angular/cli": "~20.1.0",
    "@angular/compiler-cli": "^20.1.0",
    "@types/d3-geo": "^3.0.2",
    "@types/jasmine": "~4.0.0",
    "@types/zxcvbn": "^4.4.1",
    "angular-eslint": "18.1.0",
    "babel-loader": "^8.2.5",
    "eslint": "^9.18.0",
    "jasmine-core": "~4.3.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "loader-utils": "^2.0.4",
    "typescript": "5.8.3",
    "typescript-eslint": "8.35.0"
  },
  "overrides": {
    "@angular-devkit/build-angular": {
      "babel-loader": "$babel-loader",
      "loader-utils": "$loader-utils",
      "resolve-url-loader": {
        "adjust-sourcemap-loader": {
          "loader-utils": "$loader-utils"
        }
      }
    }
  }
}
